module.exports = __webpack_public_path__ + "static/media/third_card.9462f04d.svg";